export enum ResponsibleType {
    sag = 'sag',
    rc = 'rc',
    all = 'all',
    my = 'my'
}
